import { render, staticRenderFns } from "./BankAddModal.vue?vue&type=template&id=5d19421d&scoped=true"
import script from "./BankAddModal.vue?vue&type=script&lang=js"
export * from "./BankAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19421d",
  null
  
)

export default component.exports